import * as yup from 'yup';

export interface INewComment<T> {
  content: string;
  type: T;
}
export const commentSchema = <T>() =>
  yup.object().shape({
    content: yup.string().required().nullable(),
    type: yup.mixed<T>().required().nullable(),
  });
